import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
/**
 * 対象要素を上の階層に表示させるためのコンポーネント
 */
export const Portal = (props) => {
    const { children, selector = '.portal-root' } = props;
    // モーダル表示用の element
    const [element, changeElement] = useState(null);
    useEffect(() => {
        changeElement(document.querySelector(selector));
    }, [changeElement, selector]);
    return element ? createPortal(children, element) : null;
};
